import {
    HttpErrorResponse,
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpInterceptorFn,
    HttpRequest
} from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';

import {APP_URLS, AppUrls} from 'libs/shared/environment/src/lib/tokens/url.token';

function bffLogin(): void {
    const currentUrl = encodeURI(location.pathname + location.search);
    location.href = `/bff/login?returnUrl=${currentUrl}`;
}

function memberBffLogin(): void {
    // need this check for LTI
    if (window.top !== window.self) {
        return;
    }

    bffLogin();
}

let loginInProgress = false;

function createAuthInterceptor(loginFn: () => void): HttpInterceptorFn {
    return (request, next) => {
        return next(request).pipe(
            catchError((err: HttpErrorResponse) => {
                if (err.status === 401 && !loginInProgress) {
                    loginInProgress = true;
                    loginFn();
                }
                return throwError(() => err);
            })
        );
    };
}

export const authInterceptor = createAuthInterceptor(bffLogin);

export const memberAuthInterceptor = createAuthInterceptor(memberBffLogin);

/**
 * @deprecated we should prefer functional interceptors https://v21.angular.dev/guide/http/interceptors
 */
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    private loginInProgress = false;

    constructor(@Inject(APP_URLS) protected appUrls: AppUrls) {}

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        return next.handle(request).pipe(
            catchError((err: HttpErrorResponse) => {
                if (err.status === 401 && !this.loginInProgress) {
                    this.loginInProgress = true;
                    bffLogin();
                }
                return throwError(() => err);
            })
        );
    }
}
